import store from '../store';
import Sound from '../classes/sound';
import AuthService from '../services/auth.service';

export default VueInstance => {
    const sound = new Sound(),
        auth    = new AuthService();
    VueInstance.prototype.$getBalance = () => store.state.game.balance;
    VueInstance.prototype.$getProductionQueue = () => store.state.game.productionQueue;
    VueInstance.prototype.$increaseBalance = amount => {
        store.commit({ type: 'INCREASE_BALANCE', amount });
    };
    VueInstance.prototype.$decreaseBalance = amount => {
        store.commit({ type: 'DECREASE_BALANCE', amount });
    };
    VueInstance.prototype.$playSound = id => sound.play(id);
    VueInstance.prototype.$getUser = () => auth.getUser();
    VueInstance.prototype.$getAPIURL = () => store.state.game.apiURL;
};
